export function generateAriaLabels(locStrings) {
    var _a = locStrings.firstRunGeneralResources, backButtonAriaLabel = _a.backButtonAriaLabel, closeButtonAriaLabel = _a.closeButtonAriaLabel, completeExperienceButtonAriaLabel = _a.completeExperienceButtonAriaLabel, nextButtonAriaLabel = _a.nextButtonAriaLabel, nextSlideAnnouncementAriaLabel = _a.nextSlideAnnouncementAriaLabel, paginationAriaLabel = _a.paginationAriaLabel, slideAriaLabel = _a.slideAriaLabel;
    return {
        backButtonAriaLabel: backButtonAriaLabel,
        closeButtonAriaLabel: closeButtonAriaLabel,
        completeExperienceButtonAriaLabel: completeExperienceButtonAriaLabel,
        nextButtonAriaLabel: nextButtonAriaLabel,
        nextSlideAnnouncementAriaLabel: nextSlideAnnouncementAriaLabel,
        paginationAriaLabel: paginationAriaLabel,
        slideAriaLabel: slideAriaLabel,
    };
}
//# sourceMappingURL=generateAriaLabels.js.map